// Centralised Contact-event tracker. Every lead-generating click/submission on the
// storefront funnels through here so Meta Pixel ("Contact" standard event, with CAPI
// relay for dedup) and GA4 ("generate_lead" with `method` param) stay in sync.
//
// Usage:
//   import { trackContact } from "@/lib/trackContact";
//   <a href="https://wa.me/..." onClick={() => trackContact("whatsapp", "header")}>...
//
// `channel` is the canonical lead medium ("whatsapp" | "email" | "phone" | "form").
// `source` is a free-form breadcrumb for in-house analytics (e.g. "header",
// "product_detail", "footer") so we can rank which placement converts best. The
// helper is a no-op if the Pixel helper hasn't initialised yet — never throws.
export function trackContact(channel, source) {
  if (typeof window === "undefined") return;
  const fn = window.audrivioTrack;
  if (typeof fn !== "function") return;
  try {
    fn("Contact", { channel, source });
  } catch { /* never let analytics break UX */ }
}
